/*
 * 文件管理接口
 * */
import services from "../config/axios";
import base from "./base"; // 导入接口域名列表

// 定义参数类型
type paramsType<T> = {
    [key: string]: T;
};

const fileManageAPI = {
    // 文件上传接口
    upload(file: File | FormData) {
        return services.post(`${base.lk}/Upload/PostFile`, file);
    },
    // 文件上传接口
    downloadShareFile(params: FormData) {
        return services.post(`${base.lk}/Upload/DownloadShareFile`, params);
    },
    // 下载发布申请的文件
    downloadPublishFile(params: any) {
        return services.post(`${base.lk}/Upload/DownloadPublishFile`, params, {
            responseType: "blob",
        });
    },
    //下载Tableau许可申请附件
    downloadTableauFile(params: FormData) {
        return services.post(`${base.lk}/Upload/DownloadTableauFile`, params);
    },
    // 文件列表
    getUserFileList<T>(params: paramsType<T>) {
        return services.get(`${base.lk}/fileManagement/getUserFileList`, {
            params: params,
        });
    },
    // 添加文件
    getAddFileInfo<T>(params: paramsType<T>) {
        return services.post(`${base.lk}/fileManagement/addFileInfo`, params);
    },
    // 下载发布申请的文件python
    downloadPublishFilePython(params: any) {
        return services.post(
            `${base.lk}/Upload/DownloadPublishFilePython`,
            params,
            {
                responseType: "blob",
            }
        );
    },
    // 下载组件的文件
    downloadComponentFile(params: any) {
        return services.post(
            `${base.lk}/Upload/DownloadComponentFile`,
            params,
            {
                responseType: "blob",
            }
        );
    },
    // 下载新闻封面
    downloadNewsCover(params: FormData) {
        return services.post(`${base.lk}/Upload/DownloadNewsCover`, params);
    },
};

export default fileManageAPI;
